import {SearchFilter, SearchParamRequest} from "../../api/generated/model";

export class BasicSearchParams implements SearchParamRequest {
	public constructor(pageSize?: number) {
		this.pageSize = pageSize || this.pageSize;
	}

	searchFilters: SearchFilter[] = [];
	pageNumber: number = 0;
	pageSize: number = 10;
	sortAscending: boolean = true;
	sortColumn: string = "";
}
